import { isCacheReady } from '@pinia/colada-plugin-cache-persister';

// La caché persistida vive en IndexedDB (asíncrono): hay que esperar a que se cargue
// antes de montar la app para que las queries arranquen con los datos guardados.
export default defineNuxtPlugin({
  name: 'pinia-colada-cache',
  dependsOn: ['Pinia Colada'],
  async setup() {
    if (!import.meta.env.VITEST) {
      await isCacheReady();
    }
  },
});
